import clientInformation, { getClientItem } from '../login/ClientInfo';
import { RequestPersonToPersonPayout } from "../../services/PayoutService";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, GetCustomerInfo } from "../../services/AuthenticationService";
import BeatLoader from "react-spinners/BeatLoader";
import { onlyNumbers, BonusString } from '../helpers/common';
import { isMobile } from 'react-device-detect';
import { useTranslations } from '../../context/LanguageContext';
import translations from '../../translations/PayoutP2PMethods';

export const PayoutP2PMethods = () => {
    const t = useTranslations(translations);
    const clientInfo = clientInformation();
    let INSTANCEID = clientInfo.InstanceID;
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    const [isProcessing, setIsProcessing] = useState(false);
    const { id } = useParams();
    const [arrayPayouts, setPayouts] = useState(JSON.parse(getClientItem('arrayPayoutsMethods')).filter(function (element) { return element.PayoutID === 'MoneyGram'; })[0]);
    const navigate = useNavigate();
    const [arrayCustomerInfo, setArrayCustomerInfo] = useState([]);
    const [showComponent, setshowComponent] = useState(false);
    const [OriginalAmount, setOriginalAmount] = useState(0);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(

        )
            .catch(function (error) {
                navigate('/expired/');
            })

        if (arrayPayouts === undefined) {
            navigate('/payouts/');
        }

        CustomerInfo();

    }, [])

    async function CustomerInfo() {
        await GetCustomerInfo(getClientItem('Token')).then(function (response) {
            if (response.Authentication.ErrorDescription != "Invalid input data") {
                setArrayCustomerInfo(response.Authentication);

            }
            else {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + response.Authentication.ErrorDescription, 'error');

            }
        })
            .catch(function (error) {

                Alerts.ShowAlert(t.error, t.errorGettingCustomerInfo + error.response.data.Authentication.ErrorDescription, 'error');
            })
    }

    async function doRequestEWalletPayout(Amount, comments) {
        if (parseFloat(Amount.replace(",", "").replace(" ", "")) <= parseFloat(clientInfo.WithdrawalBalance.replace(",", "")) && parseFloat(Amount.replace(",", "").replace(" ", "")) > 0) {

            var PayoutData = {
                "Token": getClientItem('Token'),
                "Amount": Amount.replace(",", ""),
                "CurrencyCode": clientInfo.CurrencyCode,
                "PaymentMethod": arrayPayouts?.PayoutID,
                "IPv4Address": clientInfo.IPAddres,
                "Comments": comments
            };

            await RequestPersonToPersonPayout(PayoutData).then(function (response) {

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.Status,
                        ProcessorName: arrayPayouts?.PayoutID
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.ErrorCode === "") {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'info');
                    navigate('/payouts/');
                } else {
                    if (isMobile)
                        Alerts.ShowAlertFullScreen(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                    else
                        Alerts.ShowAlert(t.withdrawalStatus, response.Authentication.HtmlResponse, 'warning');
                }
            })
                .catch(function (error) {
                    Alerts.ShowAlert(t.withdrawalStatus, error.response.data.Authentication.HtmlResponse, 'error');
                })
        }
        else {
            if (isMobile)
                Alerts.ShowAlertFullScreen(t.withdrawalStatus, t.amountNotPermitted, 'warning');
            else
                Alerts.ShowAlert(t.withdrawalStatus, t.amountNotPermitted, 'warning');
        }

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, comments } = Object.fromEntries(data.entries());

            if (amount != '') {
                setIsProcessing(true);
                setOriginalAmount(amount);
                await doRequestEWalletPayout(amount, comments);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert(t.warning, t.amountRequired, 'warning');
            }

        }
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px" }} src={"/svg/" + arrayPayouts?.ImageName + ".svg"} />  <span className="payout-title">{t.withdrawUsing} {arrayPayouts?.PayoutID} </span>
                    </span>
                </div>
                <div className="row m-2">
                    <div className="col-md-6 col-sm-12">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                    <select className="form-control selectcurrency" disabled name="ccCurrency" required value={clientInfo.CurrencyCode}>
                                        <option value="" className="">{t.currency}</option>
                                        <option value="USD">USD</option>
                                    </select>
                                </span>
                            </div>
                            <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder={t.amount} max={arrayPayouts?.MaxPayout === 0 ? MAXLIMIT : arrayPayouts?.MaxPayout} min={arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} name="amount" required="required" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0} />
                        </div>

                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                            {t.payoutLimits} {arrayPayouts?.MinPayout === 0 ? 1 : arrayPayouts?.MinPayout} USD {t.maximum} {arrayPayouts?.MaxPayout === 0 ? t.noLimit : arrayPayouts?.MaxPayout + ' USD'}
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="firstname">{t.firstName}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="firstname"
                            name="firstname"
                            value={arrayCustomerInfo.Name}
                            aria-label="First Name"
                            placeholder={t.firstNamePlaceholder}
                            disabled
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="lastname">{t.lastName}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="lastname"
                            name="lastname"
                            value={arrayCustomerInfo.LastName}
                            aria-label="Last Name"
                            placeholder={t.lastNamePlaceholder}
                            disabled
                        />
                    </div>
                </div>

                <div className="row m-2">
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="country">{t.country}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="country"
                            name="country"
                            value={arrayCustomerInfo.Country}
                            aria-label="Country"
                            placeholder={t.countryPlaceholder}
                            disabled
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="state">{t.state}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="state"
                            name="state"
                            value={arrayCustomerInfo.State}
                            aria-label="State"
                            placeholder={t.statePlaceholder}
                            disabled
                        />
                    </div>
                </div>

                <div className="row m-2">
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="city">{t.city}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="city"
                            name="city"
                            value={arrayCustomerInfo.City}
                            aria-label="City"
                            placeholder={t.cityPlaceholder}
                            disabled
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="address">{t.address}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="address"
                            name="address"
                            value={arrayCustomerInfo.Address}
                            aria-label="Address"
                            placeholder={t.addressPlaceholder}
                            disabled
                        />
                    </div>
                </div>

                <div className="row m-2">
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="zipcode">{t.zipCode}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="zipcode"
                            name="zipcode"
                            value={arrayCustomerInfo.ZipCode}
                            aria-label="Zip Code"
                            placeholder={t.zipCodePlaceholder}
                            disabled
                        />
                    </div>
                    <div className="col-md-6 col-sm-12">
                        <label htmlFor="phonenumber">{t.phone}</label>
                        <input
                            type="text"
                            className="form-control"
                            id="phonenumber"
                            name="phonenumber"
                            value={arrayCustomerInfo.Phone}
                            aria-label="Phone"
                            placeholder={t.phonePlaceholder}
                            disabled
                        />
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-md-12 col-sm-12 mb-3">
                        <textarea rows="3" cols="75" className="form-control" id="comments" aria-describedby="lblcomments" placeholder={t.comments} name="comments" required="required" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-danger text-center" role="alert">
                            {t.moneygramInfo}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4" onClick={() => navigate('/payouts/')}>{t.back}</button>
                        <button type="submit" className="btn btn-deposit btn-deposit-order mb-4 submit">{t.submit}</button>
                    </div>
                </div>


            </form>
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>
    );

}
